import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import HeaderLinks from './header-links'
import './header.css'

const Header = (props) => {
  const [isContactVisible, setIsContactVisible] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  return (
    <header
      data-role="Header"
      className={`header-header ${props.rootClassName} `}
    >
      <div className="header-container1">
        <a
          href="https://www.stj.jus.br/sites/portalp/Paginas/Comunicacao/Noticias/2024/26012024-Crime-de-tortura-previsto-na-Lei-9-455-pode-ter-agravante-do-Codigo-Penal-para-delito-contra-descendente.aspx"
          target="_blank"
          rel="noreferrer noopener"
          className="header-link"
        >
          Crime de tortura previsto na Lei 9.455 pode ter agravante do Código
          Penal para delito contra descendente
        </a>
      </div>
      <Link to="/" className="header-navlink">
        <img
          alt={props.imageAlt}
          src={props.imageSrc}
          loading="eager"
          className="header-image1"
        />
      </Link>
      <div className="header-container2">
        <div className="header-nav1">
          <HeaderLinks
            text="Início"
            text1="Blog"
            text2="Processo"
            text3="Sobre"
            text4="Notícias"
            rootClassName="rootClassName17"
          ></HeaderLinks>
        </div>
      </div>
      <div data-role="BurgerMenu" className="header-burger-menu">
        <button
          type="button"
          onClick={() => setIsVisible(true)}
          className="header-button1 button"
        >
          <svg viewBox="0 0 1024 1024" className="header-icon1">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </button>
      </div>
      {isVisible === true && (
        <div data-role="MobileMenu" className="header-mobile-menu">
          <div className="header-nav2">
            <div className="header-container3">
              <img
                alt={props.imageAlt1}
                src={props.imageSrc1}
                className="header-image2"
              />
              <button
                type="button"
                onClick={() => setIsVisible(false)}
                className="header-button2 button"
              >
                <svg viewBox="0 0 1024 1024" className="header-icon3">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </button>
            </div>
            <HeaderLinks rootClassName="rootClassName18"></HeaderLinks>
          </div>
        </div>
      )}
    </header>
  )
}

Header.defaultProps = {
  rootClassName: '',
  imageAlt1: 'image',
  imageSrc: '/logo.svg',
  imageAlt: 'logo',
  imageSrc1: '/logo.svg',
}

Header.propTypes = {
  rootClassName: PropTypes.string,
  imageAlt1: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  imageSrc1: PropTypes.string,
}

export default Header
